var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileAccountInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00005 20.0281C1.00005 16.1155 4.17181 12.9438 8.08438 12.9438V12.9438C9.38914 12.9438 8.60486 12.9438 10.45 12.9438C12.2952 12.9438 11.4798 12.9438 12.7845 12.9438V12.9438C16.7143 12.9438 19.9 16.1295 19.9 20.0593V21.2125H1.00005V20.0281Z",
    stroke: "#404554",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.45 10.45C13.0596 10.45 15.175 8.33455 15.175 5.725C15.175 3.11545 13.0596 1 10.45 1C7.8405 1 5.72504 3.11545 5.72504 5.725C5.72504 8.33455 7.8405 10.45 10.45 10.45Z",
    stroke: "#404554",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAccountInactive);
export default __webpack_public_path__ + "static/media/MobileAccountInactive.d54d080d.svg";
export { ForwardRef as ReactComponent };